export default __webpack_public_path__ + "static/media/facebook_post_3.223f6ceb.jpg";